export const getAllYoutubeVideos = state => state.analyticsAssetList.get('youtubeVideos');
export const getFilteredYoutubeVideos = state => state.analyticsAssetList.get('filteredYoutubeVideos');
export const getAllInstagramPosts = state => state.analyticsAssetList.get('instagramPosts');
export const getFilteredInstagramPosts = state => state.analyticsAssetList.get('filteredInstagramPosts');
export const getAllFacebookPosts = state => state.analyticsAssetList.get('facebookPosts');
export const getFilteredFacebookPosts = state => state.analyticsAssetList.get('filteredFacebookPosts');
export const getAllTwitterPosts = state => state.analyticsAssetList.get('twitterPosts');
export const getFilteredTwitterPosts = state => state.analyticsAssetList.get('filteredTwitterPosts');
export const getUserVideos = state => state.analyticsAssetList.get('userVideos');
export const getCampaignVideos = state => state.analyticsAssetList.get('campaignVideos');
export const getSortBy = state => state.analyticsAssetList.get('sortBy');
export const getFilterBy = state => state.analyticsAssetList.get('filterBy');



/** WEBPACK FOOTER **
 ** ./src/selectors/analytics-asset-list-selectors.js
 **/